import React from 'react';
import PropTypes from 'prop-types';
import { svgSprite } from '../../../hybrid/wrappers';
import { generateGridStyles } from '../components/helpers';
import { generateUniqueId } from '../../../common/utils/utils';

const Check = ({ val, getHandlers, gridStyles, name }) => {
    const { stylers, classes, existSt } = generateGridStyles(gridStyles, name);

    return (
        <p key={generateUniqueId()} {...getHandlers(false)} className={classes.wrapper} style={stylers.wrapper}>
            {svgSprite(Boolean(val) ? 'angle-up' : 'angle-down', {
                style: existSt('ico') || {
                    fill: `${gridStyles.thead}${val}`,
                    width: '15px',
                    height: '10px'
                },
                className: classes.ico
            })}
        </p>
    );
};
Check.propTypes = {
    getHandlers: PropTypes.func,
    gridStyles: PropTypes.object,
    val: PropTypes.oneOfType([PropTypes.object, PropTypes.number, PropTypes.string, PropTypes.bool]),
    name: PropTypes.string
};
export default Check;
